import { useEffect, useState } from 'react';

const STALE_MS = 15 * 60 * 1000; // 15 minutes

// After long idle (tab hidden / machine asleep) the Google vector-map style
// session expires and default POI bubbles/address markers leak through.
// Returns an epoch that increments on wake-after-idle; include it in the
// Google map container's React key to force a clean remount.
export const useMapStaleGuard = () => {
  const [epoch, setEpoch] = useState(0);
  useEffect(() => {
    let hiddenAt = null;
    let lastTick = Date.now();
    const onVisibility = () => {
      if (document.visibilityState === 'hidden') {
        hiddenAt = Date.now();
      } else {
        if (hiddenAt && Date.now() - hiddenAt > STALE_MS) {
          setEpoch((e) => e + 1);
        }
        hiddenAt = null;
        lastTick = Date.now();
      }
    };
    // Heartbeat catches machine sleep while the tab stays visible
    const iv = setInterval(() => {
      const now = Date.now();
      if (now - lastTick > STALE_MS && document.visibilityState === 'visible') {
        setEpoch((e) => e + 1);
      }
      lastTick = now;
    }, 60000);
    document.addEventListener('visibilitychange', onVisibility);
    return () => {
      document.removeEventListener('visibilitychange', onVisibility);
      clearInterval(iv);
    };
  }, []);
  return epoch;
};
